<template>
    <div class="animated fadeIn">
      <b-row>
        <b-col md="12">
          <b-card>
            <div slot="header">
              <strong>Upload / Edit Week Off's</strong>
              <div class="card-header-actions">
                <button
                  class="btn btn-sm btn-primary ml-4"
                  v-on:click="refresh()"
                  type="button"
                >
                  <i class="fa fa-refresh"></i>
                </button>
              </div>
            </div>
  
            <div class="mb-1">
              <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
                 <b-row> 
             
            <b-col sm="4">
              <b-form-group label="Select Hub:"  :label-cols="3" >
            <template #label>
            <span>Select Hub:</span> <span style="color: red"> *</span>
            </template>
              <b-form-select  v-model="selectedhub">
              <option :value="selected">-- Select Hub --</option>
              <option :value="hub.hubid" v-for="hub in hubItems"  :key="hub.hubid" >
              {{hub.hubname}}
              </option>
  
              </b-form-select>
  
              </b-form-group>
            </b-col>
  
            <b-col sm="6">
              <b-form-group label="Date Range :"  :label-cols="3" >
                <template #label>
            <span>Date Range :</span> <span style="color: red"> *</span>
            </template>
                  <date-picker :clearable="false"  name="startdate endate" v-model="time3" :placeholder="['Start date', 'End date']" :input-attr="{ readonly: true }" @change="daterange()"  :disabled-date="disabledFutureDates" range format="DD/MM/YYYY" ></date-picker>
  
  
               </b-form-group>
            </b-col>
            
          </b-row>
  
          <b-row>
  
            <!-- <b-col sm="4">
              <b-form-group label="Comments:"  :label-cols="3" >
                <template #label>
            <span>Comments:</span> <span style="color: red"> *</span>
            </template>
            <b-form-textarea name="searching" :class="{'input': true, 'is-danger': errors.has('form-1.searching') }" v-validate="'required|'" v-model.trim="searching" style="height:100px" placeholder="Comments" ></b-form-textarea> 
            
            <span v-show="errors.has('form-1.searching')" id="showerror" class="help text-danger">{{ errors.first('form-1.searching') }}</span>
  
              </b-form-group>
              
            </b-col> -->
  
            <b-col sm="4">
              <b-form-group label="Comments:"  :label-cols="3" >
                <template #label>
                <span>Comments:</span> <span style="color: red"> *</span>
                </template>
                <b-form-textarea name="searching" :class="{'input': true, 'is-danger': errors.has('form-1.searching') }" v-validate="'required|'" v-model.trim="searching" style="height:100px" placeholder="Comments" ></b-form-textarea> 
                
                <span v-show="errors.has('form-1.searching')" id="showerror" class="help text-danger">{{ errors.first('form-1.searching') }}</span>
  
                  </b-form-group>
  
              <span>Notes:</span>
                  <div style="margin-left: 20px;">
                    <div>&bull; To Upload Roaster write "W/O" againsts the Date</div>
                    <div>&bull; To Make Changes Can update "A" or "P|A" to W/O</div>
                    <div>&bull; can remove "W/O" againsts the dates</div>
                  </div>
  
  
            </b-col>
  
  
  
  
  
  
            <b-col md="4">
              <label><b>Upload CSV File <span style="color: red;">*</span></b></label>
                        
              <b-form-file
                        :disabled="!time3.length"
                        type="file"
                        v-model="file"
                        :state="Boolean(file)"
                        @change="selectcsvFiletoUpload($event)"
                        placeholder="Upload CSV File"
                        accept=".csv"
                        required
                        v-validate="'required|'"
                        :class="{
                          file: true,
                          'is-invalid': errors.has('form-1.file'),
                        }"
                      ></b-form-file>
                      <b style="color:red;">{{ validationMessage }}</b> 
  
                      <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i
                            class="fa fa-warning"
                            v-show="errors.has('file')"
                          ></i>
                        </span>
                        <code
                          v-show="errors.has('form-1.file')"
                          id="addmblnbrmsg"
                          class="help text-danger"
                          >{{ errors.first("form-1.file") }}
                        </code>
                      </b-input-group>
                      <label for="name" v-if="time3.length > 0"
                        >
                        <button type="button" @click="generateAndDownloadCSV" class="btn btn-primary btn-sm ">Download Sample Report</button>
  
                      </label>
  
            </b-col>
  
  
          </b-row>
           
          <!-- <b-row>
            <b-col sm="1">
              Note:
              
            </b-col>
            <b-col sm="8">
              <li>To upload roaster write "W/O" against the dates</li>
              <li>To make changes can update "A" or "P|A" to "W/O"</li>
              <li>can remove "W/O" against the dates</li>
            </b-col>
          </b-row> -->
          
          <b-row>
            <b-col sm="4" >
              <b-col sm="12">
              
              </b-col>
            </b-col>
             <b-col sm="8" class="my-1 text-right">
              
              <b-form-group>
               <b-button :disabled="!isValid" type="submit" size="md" variant="primary" > Upload/ Edit Roster</b-button>
             
                <!-- <b-button type="submit" size="md" variant="primary" @click="clear()" style="margin-left: 10px"> clear</b-button> -->
             
               
              </b-form-group>
            
            </b-col>
          </b-row>
  
  <br>
  <br>
              </b-form>
  
              <!-- Logs Section -->
                <b-col sm="12">
                <h4>Logs</h4>
                <br>
                <hr style="border: 1px solid black; width: 50%; margin: 20px 0;">
                <div class="filter-section">
                <b-row>
                
                                    <b-col sm="3">
                <b-form-group label="Select Hub:" :label-cols="3">
                <template #label>
                <span>Select Hub:</span>
                </template>
                <b-form-select v-model="selectedhublog">
                <option :value="selectedlog">-- Select Hub --</option>
                <option :value="hub.hubid" v-for="hub in hubItems" :key="hub.hubid">
                                            {{hub.hubname}}
                </option>
                
                                        </b-form-select>
                
                                      </b-form-group>
                </b-col>
                
                                    <b-col sm="6">
                <b-form-group label="Date Range :" :label-cols="3">
                <template #label>
                <span>Date Range :</span>
                </template>
                <date-picker :clearable="false" name="startdate endate" v-model="time4"
                                          :placeholder="['Start date', 'End date']" :input-attr="{ readonly: true }"
                                          :disabled-date="disabledFutureDates" range></date-picker>
                </b-form-group>
                </b-col>
                
                                    <b-col sm="3">
                <b-form-group label="Uploaded By" :label-cols="3">
                <template #label>
                <span>Uploaded By:</span>
                </template>
                <b-form-select v-model="selectuploadedby">
                <option :value="selecteduploadedby">-- Uploaded By --</option>
                <option :value="data.sysemailid" v-for="data in uploadedData" :key="data.sysemailid">
                                            {{data.sysemailid}}
                </option>
                </b-form-select>
                </b-form-group>
                </b-col>
                
                
                                  </b-row>
                </div>
                </b-col>
                <!-- Search Button -->
                <b-row>
                <b-col sm="12" class="text-right">
                <div>
                <b-button variant="primary" @click="searchLogs">Search</b-button>
                <b-button variant="danger" @click="clearLogs" style="margin-left: 10px ">Clear</b-button>
                </div>
                </b-col>
                
                                  </b-row>
                <br>
  
              <!-- Table Section -->
              <b-col>
                <div class="table-responsive">
                  <table class="table b-table table-bordered">
                    <thead>
                      <tr>
                        <th>File Name</th>
                        <th>Hub Name</th>
                        <th>Roaster Date Range</th>
                        <th>Uploaded by</th>
                        <th>Uploaded Date</th>
                        <th>Last Modified Date</th>
                        <th>Download Success CSV</th>
                        <th>Comments</th>
                        <th>Success Count</th>
                        <th>Failure Count</th>
                        <th>File Status</th>
                      </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in items" :key="item.id">
                        <td class="filename-column">
                        <div class="text-wrap">{{ extractFileName(item.uploadedfile) }}</div>
                        </td>
                        <td><div class="text-wrap">{{ item.hub_name }}</div></td>
                        <td><div class="text-wrap">{{ item.fromdate }} - {{ item.todate }}</div></td>
                        <td><div class="text-wrap">{{ item.emailname }}</div></td>
                        <td><div class="text-wrap">{{ item.createdat }}</div></td>
                        <td><div class="text-wrap">{{ item.updatedat }}</div></td>
                        <td>
                          <!-- Success Download Button -->
                          <button
                            type="button"
                            @click="DownloadLogSampleCsvData(item)"
                            title="Download"
                            class="btn btn-link"
                          >
                            <i class="fa fa-download"></i>
                          </button>
                        </td>
                        <td><div class="text-wrap">{{ item.remark }}</div></td>
                        <td><div class="text-wrap">{{ item.successcount }}</div></td>
                        <td>
                         <div class="text-wrap">
                        <span 
                          :class="{ 'clickable-failure-count': item.failurecount > 0 }" 
                          @click="item.failurecount > 0 && DownloadLogFailureCsvData(item)">
                          {{ item.failurecount }}
                        </span>
                      </div>
                      </td>
                        <td><div class="text-wrap">{{ item.status}}</div></td>
                      </tr>
                      <tr v-if="items.length === 0">
                        <td colspan="11" class="text-center">No Records Found</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-col>
  
              <!-- Pagination -->
           <b-col md="12" class="my-1 ">
              <paginate
                :page-count="noofpages"
                :page-range="10"
                :margin-pages="2"
                :click-handler="clickCallback"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                :page-class="'page-item'"
              >
              </paginate>
            </b-col>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </template>
  
  <script>
  import CONSTANTS from "@/utils/constants";
  import Utils from "@/utils";
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import VueTimepicker from 'vue2-timepicker'
  import 'vue2-timepicker/dist/VueTimepicker.css'
  import Papa from 'papaparse';
  import Vue from "vue";
  export default {
    name: "zonemaster",
    data: function() {
      return {
        name: "zonemaster",
        isBusy: false,
        myToggle: false,
  
        bordered: true,
        totalRows: 0,
  
        currentPage: 1,
  
        perPage: 4,
        pageOptions: [5, 10, 15],
        sortBy: null,
        options: [],
        pageNum: 1,
        noofpages: "",
        sortDesc: false,
        allowCustomValue: true,
        sortDirection: "desc",
        filter: null,
        customer: {},
        selectcsvFile: "",
        file: "",
        selectFiletype: "",
        acceptedloads: [],
        invalidload: [],
        invalidvehicleno: [],
        otherstatusload: [],
        deliveredload: [],
        invaliddeliveredload: [],
        rejectedload: [],
        bookingDateGreaterthanDeliveryDate: [],
        items: [],
        incompletedataload: [],
        resultMsg: "",
        csvdownlaod: "",
        selectedAction: "",
        selected: "",
        selectedlog: "",
        sampleBookingDoneLink: "",
        accceptedload: [],
        invalidload: [],
        alreadyRTOload: [],
        rejectedload: [],
        rejectedduetodispatchdate:[],
        selectedStatus :'',
        selectedReason :'',
        reasonList :[],
        partial_deliveredload :[],
        partial_invaliddeliveredload :[],
        partial_rejectedload : [],
        partial_incompletedataload : [],
        partial_rejectedduetodispatchdate : [],
        accessBody:[],
        isReadOnly:false,
        time3: [],
        time4: [],
        hubItems:[],
        uploadedData: [],
        optionsWH:[],
        WHData:[],
        selectedhub:'',
        selectedhublog: '',
        selecteduploadedby: '',
        selectuploadedby: '',
        searching:'',
        employeeList:[],
        headerValues:[],
        expectedColumns: [],
        presignurl:'',
        isValid: false,  
        validationMessage:'',
        samplecsvdata: [
          ['Name', 'Age', 'City'],
        ]
      };
    },
    components: {
      DatePicker,
      VueTimepicker
    },
    created: function() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      // const url = `http://65.2.154.47/api_ftl/downloadcsv?key=`;
      const url = `${CONSTANTS.MIGRATION_API_URL}/downloadcsv?key=`;
      this.csvdownlaod = url;
      this.fileName = "getadhocs3datasampleBD.csv";
      // const sampleURL = `http://65.2.154.47/api_ftl/downloadcsv?key=`;
      const sampleURL = `${CONSTANTS.MIGRATION_API_URL}/downloadcsv?key=`
      this.sampleBookingDoneLink = sampleURL;
  
      this.accessBody = userInfo.body;
        console.log("--------->>>>>>>>>>",userInfo.body)
        this.ischeckbodyvalidation();
  
      //this.getrtoreasonlist();
      this.getfcclockattendancelisting();
    },
    mounted(){
      this.daterange();
      this.setDateRange();
      this.hubListing();
      this.uploadedByListing();
    },
    // beforeDestroy() { this.$validator.pause() },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter((f) => f.sortable)
          .map((f) => {
            return { text: f.label, value: f.key };
          });
      },
    },
    filters: {
      capitalize: function(value) {
        if (!value) return "";
        value = value.toString();
        return value.charAt(0).toUpperCase() + value.slice(1);
      },
    },
    methods: {
      clickCallback (pageNum)
           {
          this.getfcclockattendancelisting(this.selectedhublog, this.time4, this.selectuploadedby, pageNum);
        },
      setDateRange() {
        const now = new Date();
        const currentMonth = now.getMonth();
        const currentYear = now.getFullYear();
  
        // Set start date to the 26th of the current month
        const startDate = new Date(currentYear, currentMonth - 1, 26);
        // Set end date to the 25th of the next month
        const endDate = new Date(currentYear, currentMonth, 25);
  
        this.time3 = [startDate, endDate];
  
  
          let timerangedata = this.time3
          let shiftstartdate = timerangedata[0]
          let shiftenddate = timerangedata[1]
  
          console.log("shiftstartdate------->",shiftstartdate);
          console.log("shiftenddate------------>",shiftenddate);
  
            const dateColumns = this.generateDateFormateRangeColumns(shiftstartdate, shiftenddate);
  
            const header = ['Sr_No', 'EMPID', 'Empl_Name','Date_of_Joining','Location','Emp_Status', ...dateColumns];
   
            this.headerValues = header;
            console.log("this.headerValues------------------->",this.headerValues);
  
      },
      DownloadLogSampleCsvData(data){
    
       // console.log("data------------------->",data);
          this.getsamplecsvdatav1(data.uploadedfile,data.createdby).then((result) => {
            this.presignurl = ''
            if(result && result.data.length > 0){
              this.presignurl = result.data[0].image
           //   this.downloadroasterUploadedFile(result[0].image)
              this.generateAndClickAnchor(result.data[0].image)
             
            }
    
          }).catch((error) =>{
            console.log('error============>',error)
          })
          
        },
        DownloadLogFailureCsvData(data){
        console.log("data------------------->",data);
          this.getsamplecsvdatav1(data.resultfile,data.createdby).then((result) => {
            this.presignurl = ''
            if(result && result.data.length > 0){
              this.presignurl = result.data[0].image
           //   this.downloadroasterUploadedFile(result[0].image)
              this.generateAndClickAnchor(result.data[0].image)
             
            }
    
          }).catch((error) =>{
            console.log('error============>',error)
          })
          
        },
        async getsamplecsvdatav1(uploadedfile,createdbyup){
            try {
          const userdata = sessionStorage.getItem("b2cuserData");
          const userInfo = JSON.parse(userdata);
              
          const obj = {
            uploadedfilepath: uploadedfile,
            createdby:createdbyup,
            
          };
          console.log("objlist", obj);
          const response = await this.$http.post(
            `${CONSTANTS.MIGRATION_API_URL}/getFcclockFilePreSignedUrl`, 
            obj
          );
  
          if (response.body.returnmsg === "Successful") {
          
            return response.body.returnvalue;
          } else {
            alert('no Data Found')
            return [];
          }
        } catch (error) {
          console.error("Error fetching sample CSV data:", error);
          return []; // Return an empty array in case of error
        }
      },
  
      generateAndClickAnchor(url) {
         const anchor = document.createElement('a');
        anchor.href = url;
        anchor.target = '_blank';
        anchor.style.display = 'none';
  
         document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
      },
  
      clearLogs () {
       this.selectedhublog = '';
       this.time4  = '';
       this.selectuploadedby  = '';
       //this.pageNum  = '';
       this.getfcclockattendancelisting(this.selectedhublog, this.time4, this.selectuploadedby, this.pageNum);
      },
     searchLogs() {
    this.items = []; // Clear items before search
    console.log("Search button clicked");
    this.getfcclockattendancelisting(this.selectedhublog, this.time4, this.selectuploadedby, this.pageNum);
  },
        extractFileName(filePath) {
      // Split the file path by '/' and return the last element
      return filePath.split('/').pop();
    },
       editItem(item) {
      // Handle the edit action here
      console.log("Editing item:", item);
      // You could navigate to an edit page or open a modal for editing.
    },
    getDownloadLink(item) {
      // Return the URL for downloading the CSV
     console.log("getDownloadLink:", item);
    },
      ischeckbodyvalidation(){
        for (let i = 0; i < this.accessBody.length; i++) {
          const element = this.accessBody[i];
       
          // if (element.title=='Adhoc Allocation' && element.isReadonly==true && this.route_id=='normal') {
          //   this.isReadOnly=true
          // }
         if (element.child) {
          for (let j = 0; j < element.child.length; j++) {
            const k = element.child[j];
             if (k.title=='Adhoc Allocation' && k.isReadonly==true) {
              this.isReadOnly=true
            }
          }
         }
        }
        console.log(" this.isReadOnly", this.isReadOnly)
      },
      MarkDeliveryStatus()
      {
        console.log("mark delivery ------------->");
       let routeData = this.$router.resolve({
             // path: '/markdelivery?userid='+tripdata.userid,
              path: '/adhocmarkdeliverystatus',
             //path: '/markdelivery',
              params: {
               
              }
            })
            window.open(routeData.href, '_blank');
      },
      getfcclockattendancelisting: function(selectedhublog,time4,selectuploadedby,pagee) {
        this.items = [];
        console.log('########################',selectedhublog,time4,selectuploadedby);
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        let shiftstartdate = '';
        let shiftenddate = '';
        let hub_id = selectedhublog ? selectedhublog : '';
        if (this.time4) {
       let timerangedata = this.time4;
  
        let formatDate = (date) => {
            if (!date) return '';
            let d = new Date(date);
            let year = d.getFullYear();
            let month = ('0' + (d.getMonth() + 1)).slice(-2); // Add leading zero if needed
            let day = ('0' + d.getDate()).slice(-2); // Add leading zero if needed
            return `${year}-${month}-${day}`;
        };
  
        shiftstartdate = timerangedata[0] ? formatDate(timerangedata[0]) : '';
        shiftenddate = timerangedata[1] ? formatDate(timerangedata[1]) : '';
        }
        this.isBusy = true;
  console.log("mark delivery ------------->",pagee);
        var csvObj = {
          page_no:pagee,
          hub_id: hub_id,
          todate: shiftenddate,
          fromdate: shiftstartdate,
          uploadedBy: selectuploadedby
        };
  
        console.log("csvObj", csvObj);
        this.$http
          .post(`${CONSTANTS.MISREPORT_API_URL}/getfcclockattendancelisting`, csvObj)
          .then((result) => {
            console.log("Result", result);
            this.isBusy = false;
  
            if (result.body.returnmsg === "Successful") {
              this.items = result.body.returnvalue;
              this.items.forEach(e => { 
               e.emailname = e.userfirstname + ' ' + e.userlastname;
              });
              this.totalRows = result.body.totalrecords;
  
              this.noofpages = parseInt(this.totalRows) / 4;
  
              this.noofpages = Math.ceil(this.noofpages);
            } else {
              this.showdata = [];
              this.items = [];
              this.totalRows = 0;
            }
          })
          .catch((ex) => {
            console.log("error-----", ex);
          });
      },
      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },
      validateForm(scope) {
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            this.uploadcsvFile();
          }
        });
      },
      // uploadcsvFile: function() {
      //   console.log("csvFile--------->",csvFile,this.selectcsvFile)
  
      //   let csvFile=this.selectcsvFile
  
      //   console.log("csvFile---->",csvFile,this.selectcsvFile)
  
      //   document.getElementById("overlay").style.display = "block";
      //   var userdata = localStorage.getItem("userData");
      //   var userInfo = JSON.parse(userdata);
  
      //   console.log("this.userInfo------>",userInfo)
      //      if (this.selectFiletype == "text/csv") {
  
      //       const reader = new FileReader();
      //       console.log("reader -------->",reader);
      //       try {
      //         reader.onload = (event) => {
      //           const csvData = event.target.result;
      //           console.log("csv data-------->",csvData);
      //           const records = this.parseCSV(csvData);
  
      //           const isValid = this.validateRecords(records);
      //           console.log("this.selectedhub-------->",this.selectedhub);
                
      //           document.getElementById("overlay").style.display = "none";
  
      //           if (this.isValid ) {
      //               let data = new FormData();
      //               let timerangedata = this.time3
      //               let shiftstartdate = timerangedata[0]
      //               let shiftenddate = timerangedata[1]
      //               console.log("shiftstartdate----->",shiftstartdate);
                
      //             data.append("weekOffFile", csvFile);
      //             data.append("createdBy", userInfo.sysemailid );
      //             data.append("premiseID", '8fe62a67-236a-4b9f-a504-320c9fac6655'); //this.selectedhub
      //             data.append("remark", this.searching );
      //             data.append("fromDate", shiftstartdate );
      //             data.append("toDate", shiftenddate );
  
      //             let config = {
      //           header: {
      //             "Content-Type": "multipart/form-data",
      //             "Authorization": "qoUbXj1kV3CV71bPANZj5g==",
      //           },
      //         };
      //         console.log("Config", config);
      //         // return false;
   
      //         this.$http  
      //           .post(`https://stagestaffattendance.fcappservices.in/api/staffattendance/rb/payroll/uploadandprocessfile`, data, {
      //             headers: {
      //               "Authorization": "qoUbXj1kV3CV71bPANZj5g==",
      //             },
      //           })
      //           .then((result) => {
      //             console.log("YYY", result);
      //             if (result.body.validationStatus === "pending") {
      //               this.$fire({
      //                 text: result.body.message,
      //                 type: "success",
      //                 timer: 30000,
      //               });
     
      //               this.selectcsvFile = "";
      //               this.selectFiletype = "";
      //               csvFile = '';
      //               this.file = "";
                   
      //             } else {
      //               this.$fire({
      //                 text: result.body.message,
      //                 type: "error",
      //                 timer: 30000,
      //               });
      //               csvFile = '';
      //               this.selectcsvFile = "";
      //               this.selectFiletype = "";
      //               this.file = "";
      //             }
      //           })
      //           .catch((ex) => {
      //             document.getElementById("overlay").style.display = "none";
      //             console.log("error", ex);
      //             csvFile = '';
      //             this.selectcsvFile = "";
      //               this.selectFiletype = "";
      //               this.file = "";
      //           });
  
                  
                   
      //           } else {
      //               this.$fire({
      //                   text: "Error: Some required fields are missing in the CSV file!",
      //                   type: "error",
      //                   timer: 30000,
      //               });
      //           }
      //       };
  
      //       reader.onerror = (error) => {
      //         this.$fire({
      //                   text: error,
      //                   type: "error",
      //                   timer: 30000,
      //               });
      //             document.getElementById("overlay").style.display = "none";
      //         };
  
      //         reader.readAsText(this.selectcsvFile);
      //       } catch (error) {
      //         console.log("err-------->",error);
      //       }
           
  
      //     } else {
      //       document.getElementById("overlay").style.display = "none";
      //       this.$fire({
      //         text: "Please Upload CSV File Only",
      //         type: "error",
      //         timer: 30000,
      //       });
      //       csvFile = '';
      //     }
      
      // },
  
      uploadcsvFile: function() {
         let csvFile=this.selectcsvFile
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata);
      //  console.log('userInfo==========>',userInfo.sysemailid)
           if (this.selectFiletype == "text/csv") {
  
            let timerangedata = this.time3
            let shiftstartdate = timerangedata[0]
            let shiftenddate = timerangedata[1]
  
            let data = new FormData();
             data.append("file", csvFile);
             data.append("fromDate", this.formatDate(shiftstartdate));
             data.append("toDate", this.formatDate(shiftenddate));
             data.append("premiseID", this.selectedhub);
             data.append("remark", this.searching);
            data.append("createdBy",userInfo.sysemailid);
             let config = {
              header: {
                "Content-Type": "multipart/form-data",
              },
            };
         //   console.log("Config", config);
            // return false;
            this.$http  
              .post(`${CONSTANTS.MISREPORT_API_URL}/updateWeeklyoffDataFile`, data, {
                headers: {
                  "Content-Type": "multipart/form-data" },
              })
              .then((result) => {
                console.log("YYY", result);
                // this.resultMsg = result.body.returnmsg;
                if (result.body.returnmsg === "Successful") {
                  this.selectcsvFile = "";
                  this.selectFiletype = "";
                  csvFile = '';
                  this.file = "";
                  this.errors.clear("form-1");
                  this.refresh()
                  this.$fire({
                    text: 'File uploaded successfully',
                    type: "success",
                    timer: 30000,
                  });
               //   this.uploadcsvfilelisting(this.pageNum);
                } else {
                  this.errors.clear("form-1");
                  this.$fire({
                    text: result.body.returnvalue,
                    type: "error",
                    timer: 30000,
                  });
                  this.refresh()
                  csvFile = '';
                  this.selectcsvFile = "";
                  this.selectFiletype = "";
                  this.file = "";
                }
              })
              .catch((ex) => {
                this.errors.clear("form-1");
                document.getElementById("overlay").style.display = "none";
                console.log("error", ex);
                csvFile = '';
                this.selectcsvFile = "";
                  this.selectFiletype = "";
                  this.file = "";
              });
          } else {
            document.getElementById("overlay").style.display = "none";
            this.$fire({
              text: "Please Upload CSV File Only",
              type: "error",
              timer: 30000,
            });
            csvFile = '';
          }
        //}
      },
  
  
  
  parseCSV(data) {
    const rows = data.trim().split('\n').map(row => row.split('\t')); // Use tab as the delimiter
      const header = rows[0].map(item => item.trim()); // First row as header
      const records = rows.slice(1).map(row => {
          const record = {};
          header.forEach((key, index) => {
              record[key] = row[index] ? row[index].trim() : ''; // Handle empty values
          });
          return record;
      });
      return records;
  },
  daterange()
  {
    console.log("date range=------->");
    let timerangedata = this.time3
                    let shiftstartdate = timerangedata[0]
                    let shiftenddate = timerangedata[1]
                      const dateColumns = this.generateDateFormateRangeColumns(shiftstartdate, shiftenddate);
  
                      const header = ['Sr_No', 'EMPID', 'Empl_Name','Date_of_Joining','Location','Emp_Status', ...dateColumns];
                      
  
    this.headerValues = header;
    console.log("header---------->",header);
    console.log("this.headerValues------------>",this.headerValues);
  },
  
  validateRecords(records) {
    
    //const headersToCheck = ['Sr_No', 'EMPID', 'EMPLY_NAME', 'DATE_OF_JOINING', 'LOCATION', 'EMP_STATUS'];
      let allValid = true;
  
      records.forEach((record, index) => {
          const emptyFields = this.headerValues.filter(header => !record[header] || record[header].trim() === '');
          if (emptyFields.length > 0) {
              console.log(`Row ${index + 2} has empty fields: ${emptyFields.join(', ')}`);
              allValid = false;
          } else {
              console.log(`Row ${index + 2} has all values present.`);
          }
      });
  
      return allValid;
  
    // return records.every(record => {
    //       const hasAllRequiredFields = this.headerValues.every(field => {
    //           return field in record && record[field] !== '';
    //       });
  
    //       return hasAllRequiredFields;
    //   });
  
      // return records.every(record => {
      //     // Validate required fields
      //     const requiredFields = ['EMPID', 'EMPLY_NAME', 'DATE_OF_JOINING', 'LOCATION', 'EMP_STATUS'];
      //     const hasAllRequiredFields = requiredFields.every(field => record[field]);
  
      //     // Validate dynamic date fields
      //     const dateFields = Object.keys(record).filter(key => !requiredFields.includes(key));
      //     const hasAllDatesFilled = dateFields.every(date => record[date]);
  
      //     return hasAllRequiredFields && hasAllDatesFilled;
      // });
  },
  
  
      uploadcsv: function() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        // this.$validator.reset();
  
        // console.log(this.myToggle)
        if (this.myToggle == true) {
          this.errors.clear("form-1");
          // this.$validator.reset("form-1");
          var addzone = document.getElementById("addzone");
          addzone.style.display = "block";
          var showerror = document.getElementById("showerror");
          showerror.style.display = "none";
          this.selectedAction = "";
          this.file = "";
          this.selectedStatus ='';
          this.selectedReason ='';
          
        } else {
          this.errors.clear("form-1");
          var addzone = document.getElementById("addzone");
          addzone.style.display = "none";
          var showerror = document.getElementById("showerror");
          showerror.style.display = "none";
          this.selectedAction = "";
          this.file = "";
          this.selectedStatus ='';
          this.selectedReason ='';
        }
      },
  
      selectcsvFiletoUpload(event) {
        this.selectcsvFile = event.target.files[0];
  
        const file = event.target.files[0];
        
          if (file) {
          const reader = new FileReader();
          reader.onload = (e) => {;
            const csvData = e.target.result;
  
            // Parse the CSV file using PapaParse
            Papa.parse(csvData, {
              complete: (results) => {
                  const actualColumns = results.meta.fields;
                if (this.validateColumns(actualColumns)) {
                  console.log('here===============')
                  console.log('esults.data=============',results.data)
                  if(results.data.length <= 0){
                      this.isValid = false;
                      this.validationMessage = 'Csv is Empty'
                  }
                  const filteredData = results.data.filter(item => item.Sr_No !== "");
  
                  this.validateRows(filteredData);
                }
              
              },
              header: true, // Treat the first row as the header
            });
          };
          reader.readAsText(file);
        }
  
        // this.imgname= this.selectedFiles.name;
    
        console.log("HHH", this.selectcsvFile);
  
        this.selectFiletype = event.target.files[0].type;
        console.log("selectFiletype", this.selectFiletype);
      },
  
      validateRows(rows) {
          const invalidRows = [];
          const columnLimit = 6;  
  
          rows.forEach((row, rowIndex) => {
            const rowKeys = Object.keys(row);
              
            const emptyFields = rowKeys.slice(0, columnLimit).filter(
              (key) => !row[key] || row[key].trim() === ''
            );
  
            if (emptyFields.length > 0) {
              invalidRows.push(`Row ${rowIndex + 1}: Empty fields - ${emptyFields.join(', ')}`);
            }
          });
  
          if (invalidRows.length > 0) {
            this.isValid = false;
            this.validationMessage = `Invalid rows found:\n${invalidRows.join('\n')}`;
          } else {
            this.isValid = true;
            this.validationMessage = '';
            
            if (rows.length <= 0) {
              this.isValid = false;
              this.validationMessage = 'CSV is Empty';
            }
          }
  },
  
      validateColumns(actualColumns) {
      // Check if the actual columns match the expected columns
      let timerangedata = this.time3
      let shiftstartdate = timerangedata[0]
      let shiftenddate = timerangedata[1]
        const dateColumns = this.generateDateFormateRangeColumns(shiftstartdate, shiftenddate);
  
        const header = ['Sr_No', 'EMPID', 'Empl_Name','Date_of_Joining','Location','Emp_Status', ...dateColumns];
  
        
  
        this.expectedColumns = this.headerValues
        console.log("actualColumns----->",actualColumns);
        console.log("this.expectedColumns----->",this.expectedColumns);
  
      const missingColumns = this.expectedColumns.filter(
          
        (col) => !actualColumns.includes(col)
      );
      const extraColumns = actualColumns.filter(
        (col) => !this.expectedColumns.includes(col)
      );
      this.isValid = false;
      console.log("missingColumns---------->",missingColumns);
      console.log("extraColumns---------->",extraColumns);
      if (missingColumns.length === 0 && extraColumns.length === 0) {
        this.isValid = true;
        this.validationMessage = '';
        return true;
       } else {
        this.isValid = false;
        this.validationMessage = `Invalid CSV!`; 
        return false;
       }
    },
  
  
      refresh: function() {
        this.errors.clear("form-1");
        // var addzone = document.getElementById("addzone");
        // addzone.style.display = "none";
        this.selectcsvFile = "";
        this.searching = '';
        this.time3 = '';
        this.selectedhub = '';
        this.selectedhublog = '';
        this.time4 = '';
        this.selectuploadedby = '';
        if(this.hubItems.length == 1)
            {
              this.selectedhub = this.hubItems[0].hubid;
            }
        
        this.selectFiletype = "";
        this.acceptedloads = [];
        this.invalidload = [];
        this.invalidvehicleno = [];
        this.otherstatusload = [];
        this.deliveredload = [];
        this.invaliddeliveredload = [];
        this.rejectedload = [];
        this.incompletedataload = [];
        this.accceptedload = [];
        this.invalidload = [];
        this.alreadyRTOload = [];
        this.rejectedload = [];
        this.getfcclockattendancelisting(this.selectedhublog, this.time4, this.selectuploadedby, this.pageNum);
        var showerror = document.getElementById("showerror");
        showerror.style.display = "none";
        this.daterange();
        this.setDateRange();
        this.hubListing();
        this.uploadedByListing();
      },
  
      clear: function() {
        this.zoneno = "";
        this.tags2 = [];
        this.searching = '';
        this.errors.clear("form-1");
      },
  
      // getrtoreasonlist(){
      //   var userdata = localStorage.getItem("userData");
      //   var userInfo = JSON.parse(userdata);
  
      //   const obj={}
      //   this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getrtoreasonlist`, obj)
      //     .then((result) => {
      //       console.log("Result", result);
  
      //       if (result.body.returnmsg === "Successful") {
      //         this.reasonList = result.body.returnvalue;
      //       } else {
      //         this.reasonList = [];
      //       }
      //     })
      //     .catch((ex) => {
      //       console.log("error-----", ex);
      //     });
      // },
  
   uploadedByListing(){
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        let hubid = userInfo && userInfo.hub_id ? userInfo.hub_id : '';
        const obj={
          sysusermasterid:`${userInfo.sysusermasterid}`,
          usertype : `${userInfo.user_type}`,
          hub_id : hubid
        }
        console.log("objlist",obj)
              this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllsystemEmails`, obj)
                .then(result => {
                  console.log("eresult.body.returnvalue-----", result.body.returnvalue);
                  if (result.body.returnmsg === 'Successful') {
                      this.uploadedData  = result.body.returnvalue;
                  } else {              
                      this.uploadedData=[]; 
                  }
              
    
              })
              .catch(ex => {
                  console.log("error-----", ex);
              });
        },
  
      hubListing(){
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        const obj={
          sysusermasterid:`${userInfo.sysusermasterid}`,
          usertype : `${userInfo.user_type}`,
        }
        console.log("objlist",obj)
              this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllHubList`, obj)
                .then(result => {
                  
                  if (result.body.returnmsg === 'Successful') {
                      this.hubItems=[];
                  
                      this.WHData  = result.body.returnvalue;
                      
                      for(let j = 0; j < this.WHData.length; j++) {
                          let WH = {
                            hubname: this.WHData[j].hub_title + " - " + this.WHData[j].fcclock_hubid,
                          hubid: this.WHData[j].id,
                          }
                      this.hubItems.push(WH);
                      }
                      if(this.hubItems.length == 1)
                      {
                        this.selectedhub = this.hubItems[0].hubid;
                      }
                   console.log("aaaaaaaa@@@@@@@@@@@@@@@@@@@@@",this.hubItems);
                  } else {              
                      this.WHData  = result.body.returnvalue;
                  }
              
    
              })
              .catch(ex => {
                  console.log("error-----", ex);
              });
        },
      convertArrayToCSV(data) {
        return data.map(row => row.join(',')).join('\n');
      },
      generateDateRangeColumns(startDate, endDate) {
  
        // console.log('startDate=========>',startDate)
        // console.log('endDate==========>',endDate)
  
        const start = new Date(startDate);
        console.log('start==============>',start)
        const end = new Date(endDate);
        // if(start!=end){
        // end.setDate(end.getDate() + 1);
        // }
        console.log('end===========>',end)
        const dateArray = [];
  
        // Generate all dates between startDate and endDate
        while (start <= end) {
          console.log('in======',start)
          const dateStr = this.formatDate(start); // Format as YYYY-MM-DD
          console.log('dateStr=========>',dateStr)
          dateArray.push(dateStr);
          start.setDate(start.getDate() + 1); // Increment by one day
          console.log('start====&==',start)
        }
  
        console.log('dateArray===========>',dateArray)
        return dateArray;
      },
      generateDateFormateRangeColumns(startDate, endDate) {
  
      // console.log('startDate=========>',startDate)
      // console.log('endDate==========>',endDate)
  
      const start = new Date(startDate);
      //console.log('start==============>',start)
      const end = new Date(endDate);
   
     // console.log('end===========>',end)
      const dateArray = [];
  
      // Generate all dates between startDate and endDate
      while (start <= end) {
       // console.log('in======',start)
        const dateStr = this.formatDate(start); // Format as YYYY-MM-DD
       // console.log('dateStr=========>',dateStr)
        dateArray.push(this.formatDateFun(start));
        start.setDate(start.getDate() + 1); // Increment by one day
        //console.log('start====&==',start)
      }
  
      console.log('dateArray===========>',dateArray)
      return dateArray;
      },
       formatDateRange(date) {
          const options = { day: '2-digit', month: 'short', year: 'numeric' };
          return date.toLocaleDateString('en-GB', options).replace(/ /g, '-');
      },
     formatDateFun(date) {
      if (!(date instanceof Date) || isNaN(date)) {
          throw new Error('Invalid Date');
      }
  
      const day = String(date.getDate()).padStart(2, '0'); // Get day
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const month = monthNames[date.getMonth()]; // Get month
      const year = String(date.getFullYear());
  
      return `${day}-${month}-${year}`; // Return formatted date
  },
      generateAndDownloadCSV() {
        console.log("selectedhub------>",this.selectedhub);
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        let timerangedata = this.time3
      let shiftstartdate = timerangedata[0]
      let shiftenddate = timerangedata[1]
  
      const dateColumns = this.generateDateFormateRangeColumns(shiftstartdate, shiftenddate);
  
      const header = ['Sr_No', 'EMPID', 'Empl_Name','Date_of_Joining','Location','Emp_Status', ...dateColumns];
      this.expectedColumns = header
        const obj={
          sysusermasterid:`${userInfo.sysusermasterid}`,
          selectedhub : `${this.selectedhub}`,
          startdate: this.formatDate(shiftstartdate),
          enddate: this.formatDate(shiftenddate),
          usertype:`${userInfo.user_type}`
  
        }
        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/payrollreportlisting`, obj)
                .then(response => {
                  if (response.body.returnmsg === "Successful") {
                    // let oo = this.groupByEMPID(response.body.returnvalue)
                  console.log("aaaaaaaa", response.body.returnvalue);
                  let oo = response.body.returnvalue;
  
                  if(oo && oo.length > 0){
  
                  const csv = this.generateCSV(header,oo, dateColumns, response.body.returnvalue);
                  this.downloadCSV(csv, 'roaster_weekly_sample.csv');
                  }
  
  
                  return oo;
                } else {
                  alert('no Data Found')
                //  console.warn("No valid data received.");
                  return [];
                }
                              
    
              })
              .catch(ex => {
                  console.log("error-----", ex);
              });
  
        return false;
       
      },
      isValidDate(dateString) {
  const date = new Date(dateString);
  return !isNaN(date.getTime());
},
  //     generateCSV(header, data, dateColumns, responseData) {
  //         // const csvRows = [];
  
  // // // Add header row
  // // csvRows.push(header.join(','));
  // // const today = new Date();
  // // // Add data rows
  // // data.forEach((row, index) => {
  // //   const values = header.map(headerItem => {
  // //          if (headerItem === 'Sr_No') {
  // //       return index + 1;
  // //     } else if (this.isValidDate(headerItem)) {
  // //       // Parse the date from the header
  // //       const cellDate = new Date(headerItem);

  // //       if (cellDate < today && (!row[headerItem] || row[headerItem] === '')) {
  // //         return 'A'; // Set to 'A' for past empty dates
  // //       } else if (cellDate >= today) {
  // //         return ''; // Keep empty for future dates
  // //       } else {
  // //         return row[headerItem] || ''; // Keep original value for valid data
  // //       }
  // //     } else {
  // //       return row[headerItem] || ''; // Handle non-date headers
  // //     }

  // //   });
  // //  // console.log('values=====>',values)
  
  // //   csvRows.push([...values].join(',')); // Add Sr_No
  // // });
  
  // // return csvRows.join('\n');
  //     const csvRows = [];
  
  //   // Add header row
  //   csvRows.push(header.join(','));

  //   // Add data rows
  //    data.forEach((row, index) => {
  //         const values = header.map(headerItem => {
  //             if (headerItem === 'Sr_No') {
  //                 return index + 1;
  //             } else if (headerItem === 'Date_of_Joining' || headerItem === 'Location' || headerItem === 'EMPID' || headerItem === 'Empl_Name' || headerItem === 'Emp_Status') {
  //                 return row[headerItem] || '';
  //             } else if (dateColumns.includes(headerItem)) {
  //                 // Check if the date is in the future
  //                 const headerDate = new Date(headerItem); // Parse the date from the header
  //                 const today = new Date();
  //                 today.setHours(0, 0, 0, 0); // Reset time for comparison

  //                 if (headerDate > today) {
  //                     return ''; // Future dates should be empty
  //                 }

  //                 const dateValue = responseData[row.EMPID] && responseData[row.EMPID][headerItem];
  //                 return dateValue ? dateValue : 'A'; // Use 'A' for past dates with no attendance status
  //             } else {
  //                 return row[headerItem] || ''; // Handle non-date headers
  //             }
  //         });
  //         csvRows.push(values.join(','));
  //     });

  //   return csvRows.join('\n');
  // },
        spaceValue(value) {
        if (typeof value === 'string') {
          return `"${value.replace(/"/g, '""')}"`;
        }
        return value;
      },
      generateCSV(header, data, dateColumns, responseData) {
        const csvRows = [];
        csvRows.push(header.map(this.spaceValue).join(','));
      
        data.forEach((row, index) => {
          const values = header.map(headerItem => {
            if (headerItem === 'Sr_No') {
              return this.spaceValue(index + 1);
            } else if (headerItem === 'EMPID') {
              return this.spaceValue(row.EMPID || '');
            } else if (headerItem === 'Empl_Name') {
              return this.spaceValue(row.Empl_Name || '');
            } else if (headerItem === 'Date_of_Joining') {
              return this.spaceValue(row.Date_of_Joining || '');
            } else if (headerItem === 'Location') {
              return this.spaceValue(row.Location || '');
            } else if (headerItem === 'Emp_Status') {
              return this.spaceValue(row.Emp_Status || '');
            } else if (dateColumns.includes(headerItem)) {
              return this.spaceValue(row[headerItem] || ''); 
            }
            return this.spaceValue('');
          });
          csvRows.push(values.join(','));
        });
      
        return csvRows.join('\n');
      },
      groupByEMPID(data) {
          const employeeMap = new Map();
  
          data.forEach(item => {
            const { EMPID, Empl_Name, Date_of_Joining, Location, Emp_Status, adate, attendancestatus } = item;
  
            if (!employeeMap.has(EMPID)) {
              // Initialize the employee object if not already present.
              employeeMap.set(EMPID, {
                EMPID,
                Empl_Name,
                Date_of_Joining,
                Location,
                Emp_Status
              });
            }
  
            employeeMap.get(EMPID)[adate] = attendancestatus;
          });
  
          return Array.from(employeeMap.values());
        },
      downloadCSV(csvData, filename) {
        const blob = new Blob([csvData], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  
    },
  };
  </script>
  
  <style scoped>
  /* IE fix */
  #card-chart-01,
  #card-chart-02 {
    width: 100% !important;
  }
  .nameOfTheClass {
    max-width: 166px !important;
  }
  .ti-new-tag-input-wrapper input[data-v-61d92e31] {
    flex: 1 0 auto;
    min-width: 310px;
    border: none;
    padding: 0px;
    margin: 0px;
  }
  #overlay {
    position: fixed; /* Sit on top of the page content */
    display: none; /* Hidden by default */
    width: 100%; /* Full width (cover the whole page) */
    height: 100%; /* Full height (cover the whole page) */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
    z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
    cursor: pointer; /* Add a pointer on hover */
  }
  #overlayyy {
    position: fixed; /* Sit on top of the page content */
    display: none; /* Hidden by default */
    width: 100%; /* Full width (cover the whole page) */
    height: 100%; /* Full height (cover the whole page) */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
    z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
    cursor: pointer; /* Add a pointer on hover */
  }
  .loaderrr {
    position: relative;
    border: 5px solid #f3f3f3;
    border-radius: 50%;
    border-top: 5px solid #3498db;
    width: 30px;
    height: 30px;
    left: 50%;
    top: 50%;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 2s linear infinite;
  }
  .loader {
    position: relative;
    border: 5px solid #f3f3f3;
    border-radius: 50%;
    border-top: 5px solid #3498db;
    width: 30px;
    height: 30px;
    left: 50%;
    top: 50%;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 2s linear infinite;
  }
  #vendor_list_scroll {
    max-height: 500px;
    overflow-x: scroll;
  }
  
  /* Safari */
  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }
  
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  
  .filter-section {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
  }
  .table-responsive {
    overflow-x: auto;
  }
  
  .filename-column {
    word-wrap: break-word;
    word-break: break-all;
    max-width: 150px; /* Adjust max width to prevent overlapping */
  }
  
  .table {
    width: 100%;
    max-width: 100%;
    table-layout: fixed; /* Ensures columns stay within width limits */
  }
  
  .table th,
  .table td {
    max-width: 150px; /* Adjust as needed */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  .table th:first-child,
  .table td:first-child {
    max-width: 300px; /* Larger width for File Name column */
  }
  .table-responsive {
    overflow-x: auto;
  }
  .table td {
    word-break: break-all;
  }
  .text-wrap {
    white-space: normal;
    word-wrap: break-word;
    max-width: 200px; /* Adjust for appropriate column width */
  }
  .clickable-failure-count {
    cursor: pointer;
    color: blue; /* Make it look like a link */
  }
  
  .clickable-failure-count:hover {
    color: darkblue; /* Add hover effect */
  }
  </style>
  